import React from 'react';
import {useParams} from 'react-router-dom';
import {
  ModuleEnum,
  PermissionOperationEnum,
  UserTypeEnum,
} from 'src/api/ProactApiClient';
import {AllUsersList} from 'src/pages/Modules/Personnel/PersonnelList/components/AllUsersList/AllUsersList';
import {PersonnelList} from 'src/pages/Modules/Personnel/PersonnelList/components/PersonnelList/PersonnelList';
import {UserActivityList} from 'src/pages/Modules/Personnel/PersonnelList/components/UserActivityList/UserActivityList';
import {PathUtility} from 'src/shared/constants/PathBuilder';
import type {PersonnelIndexViewType} from 'src/shared/constants/ViewTypes';
import useSetDocumentTitle from 'src/shared/hooks/useSetDocumentTitle';
import {useUrlQueryTabV2} from 'src/shared/hooks/useUrlQueryTabV2';
import {PersonnelDocumentTitle} from 'src/app/personnel/personnelHelpers';
import {routeRegistry} from 'src/pages/RouteRegistry';
import {useAppNavigate} from 'src/shared/hooks/useAppNavigate';

const PersonnelListPage: React.FC = () => {
  useSetDocumentTitle(PersonnelDocumentTitle);
  const navigate = useAppNavigate();
  const {view} = useParams();

  function handleRowClick(
    id: number,
    userType: UserTypeEnum,
    vendorId?: number
  ) {
    const fromTab = view ?? 'employee';
    if (userType === UserTypeEnum.Contractor) {
      if (vendorId) {
        navigate(
          `${PathUtility.VendorPersonnelView(
            id,
            vendorId,
            'overview'
          )}?from=${fromTab}`
        );
      } else {
        navigate(
          `${PathUtility.VendorListPersonnelView(
            id,
            'overview'
          )}?from=${fromTab}`
        );
      }
    } else {
      navigate(`${PathUtility.PersonnelView(id, 'overview')}?from=${fromTab}`);
    }
  }
  const {RenderedTabsComponent} = useUrlQueryTabV2<PersonnelIndexViewType>({
    view: (view ?? '') as PersonnelIndexViewType,
    defaultView: 'employee',
    tabs: [
      {
        view: 'all',
        label: 'All Users',
        component: (
          <>
            <AllUsersList onRowClick={handleRowClick} />
          </>
        ),
      },
      {
        view: 'employee',
        label: 'Employees',
        component: (
          <>
            <PersonnelList
              userType={UserTypeEnum.Employee}
              onRowClick={handleRowClick}
            />
          </>
        ),
      },
      {
        view: 'activity',
        label: 'User Activity',
        component: <UserActivityList />,
      },
    ],
    onSelectView: view =>
      navigate(PathUtility.Personnel(view as PersonnelIndexViewType)),
  });

  return <>{RenderedTabsComponent}</>;
};

export default PersonnelListPage;

// Register the route with the new system
routeRegistry.registerPageRoute({
  backNavigation: 'page',
  path: PathUtility.Personnel(':view'),
  element: <PersonnelListPage />,
  module: ModuleEnum.Personnel,
  operation: PermissionOperationEnum.View,
  isPrivate: true,
});
